import React from 'react';
import { Route, Routes } from 'react-router-dom-v5-compat';

import WhatToExpectPage from '../WhatToExpectPage/WhatToExpectPage';

import SkillsPage from './SkillsPage/SkillsPage';
import CatCareDetailsPage from './CatCareDetailsPage';
import DogCareDetailsPage from './DogCareDetailsPage';
import SitterProfileContent from './SitterProfileContent';

const SitterProfilePage: React.FC = () => {
  return (
    <Routes>
      <Route path="/provider-profile/details/dog-care-details" element={<DogCareDetailsPage />} />
      <Route path="/provider-profile/details/cat-care-details" element={<CatCareDetailsPage />} />
      <Route path="/provider-profile/details/skills" element={<SkillsPage />} />
      <Route path="/provider-profile/details/what-to-expect" element={<WhatToExpectPage />} />
      <Route path="/provider-profile/details" element={<SitterProfileContent />} />

      {/* Existing Provider Sign-Up (EPSU) routes */}
      <Route
        path="/provider-profile/existing-provider-sign-up/:serviceSlug/details/dog-care-details"
        element={<DogCareDetailsPage />}
      />
      <Route
        path="/provider-profile/existing-provider-sign-up/:serviceSlug/details/cat-care-details"
        element={<CatCareDetailsPage />}
      />
      <Route
        path="/provider-profile/existing-provider-sign-up/:serviceSlug/details/skills"
        element={<SkillsPage />}
      />
      <Route
        path="/provider-profile/existing-provider-sign-up/:serviceSlug/details/what-to-expect"
        element={<WhatToExpectPage />}
      />
      <Route
        path="/provider-profile/existing-provider-sign-up/:serviceSlug/details"
        element={<SitterProfileContent />}
      />
    </Routes>
  );
};

export default SitterProfilePage;
